import {configureStore} from '@reduxjs/toolkit';
import { authReducer } from '@penn/web-common';
import selectorReducer from '../api/redux-toolkit/reducer/selectorSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    selector: selectorReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;